import React, { useState } from 'react';
import {
  TextField,
  Typography,
  Button,
  Box
} from '@mui/material';
import ColorPalette from '../../../../colorpalette/ColorPalette';
import PopupBase from '../../../../popup/base/PopupBase';

const CreateReplacementRecordDialog = ({
  open,
  onClose,
  onConfirm,
  isSubmitting,
  initialAssessment = '',
  initialEvolution = ''
}) => {
  const [assessment, setAssessment] = useState(initialAssessment);
  const [evolution, setEvolution] = useState(initialEvolution);

  // Reset form when dialog opens with new data
  React.useEffect(() => {
    if (open) {
      setAssessment(initialAssessment);
      setEvolution(initialEvolution);
    }
  }, [open, initialAssessment, initialEvolution]);

  const handleClose = () => {
    onClose();
  };

  const handleConfirm = () => {
    onConfirm(assessment, evolution);
  };

  if (!open) return null;

  const dialogContent = (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <Typography variant="body1">
        Você está criando um novo registro para substituir um registro anulado.
        Edite as informações conforme necessário:
      </Typography>
      
      <Box>
        <Typography variant="subtitle2" sx={{ fontWeight: 600, marginBottom: '8px' }}>
          Avaliação
        </Typography>
        <TextField
          id="assessment"
          type="text"
          fullWidth
          multiline
          rows={4}
          variant="outlined"
          value={assessment}
          onChange={(e) => setAssessment(e.target.value)}
        />
      </Box>
      
      <Box>
        <Typography variant="subtitle2" sx={{ fontWeight: 600, marginBottom: '8px' }}>
          Evolução
        </Typography>
        <TextField
          id="evolution"
          type="text"
          fullWidth
          multiline
          rows={4}
          variant="outlined"
          value={evolution}
          onChange={(e) => setEvolution(e.target.value)}
        />
      </Box>
    </Box>
  );

  const negativeButton = (
    <Button
      onClick={handleClose}
      variant="outlined"
      sx={{ color: ColorPalette.textMedium }}
    >
      Cancelar
    </Button>
  );

  const positiveButton = (
    <Button
      onClick={handleConfirm}
      variant="contained"
      disabled={!assessment.trim() || !evolution.trim() || isSubmitting}
      sx={{
        backgroundColor: ColorPalette.blueMain,
        '&:hover': {
          backgroundColor: ColorPalette.blueDark
        }
      }}
    >
      Criar Substituição
    </Button>
  );

  return (
    <PopupBase
      Title="Criar Registro de Substituição"
      Content={dialogContent}
      NegativeButton={negativeButton}
      PositiveButton={positiveButton}
      OnClose={handleClose}
      maxWidth="md"
    />
  );
};

export default CreateReplacementRecordDialog;